import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";

export default function MyConnects() {
  const { startLoader, stopLoader } = useLoader();
  const [connects, setConnects] = useState(0);

  useEffect(() => {
    const getConnects = () => {
      startLoader();
      axiosInstance
        .get("/api/payments/current_user/")
        .then((resp) => {
          stopLoader();
          if (resp.status === 200 || resp.status === 201) {
            const Data = resp.data;
            setConnects(Data[0].connects);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getConnects();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="my-jobs pc-p-3">
        <div className="container">
          <div className="primary-heading color-dark mb-4">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6 col-6">
                <h4>Connects History</h4>
              </div>
            </div>
          </div>
          <div className="connects-box">
            <div className="row align-items-end">
              <div className="col-lg-9 col-md-9 col-12">
                <div className="primary-heading color-dark">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-6">
                      <h6>My Balance</h6>
                      <h4>{connects} Connects</h4>
                    </div>
                    {/* <div className="col-lg-6 col-md-6 col-6">
                              <a href="javacript:void(0)" className="primary-btn secondary-bg">Buy Connects</a>
                          </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-12">
                <div className="side-img">
                  <img src="/assets/connects-img.png" alt="Connects" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
